import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/utils/services/api.service';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { DataTableDirective } from 'angular-datatables';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-user-all-transcation',
  templateUrl: './user-all-transcation.component.html',
  styleUrls: ['./user-all-transcation.component.scss']
})
export class UserAllTranscationComponent implements OnInit {
  dtOptions: any = {};
  [x: string]: any;
  allUser: any;
  render: number;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;

  constructor(
    private apiService: ApiService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.apiHost = environment.API_HOST;
    this.dtOptions = {
      pagingType: 'full_numbers',
      // scrollX: true,
      pageLength: 10,
      dom: 'Bfrtip',
      //buttons: ['excel']
    };
    this.route.paramMap.subscribe(params => {
      this.tourId = params.get('id');
      // console.log(this.tourId); 
    });
    this.UserReport();
  } 
  UserReport() {
    // const userId = this.tourId
    //console.log(userId, "nihsdfhs");
    this.apiService.getallTransactionBYuser(this.tourId).subscribe((res: any) => {
      // console.log(res, 'invoiceeeee');
      // this.data = res.data[0]
      this.allData = res.data
      // console.log(this.allData)
      if (this.isDtInitialized) {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next();
        });
      } else {
        this.isDtInitialized = true;
        this.dtTrigger.next();
      }
    });
  }

  openLink(invoice) {
    // console.log(invoice)
    //return
    // Replace 'https://example.com/image.jpg' with the actual URL of the image or website you want to open
    window.open(this.apiHost + invoice, '_blank');
}


  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

}
